import { render, staticRenderFns } from "./TimeAgo.vue?vue&type=template&id=7d93a159&scoped=true&"
import script from "./TimeAgo.vue?vue&type=script&lang=js&"
export * from "./TimeAgo.vue?vue&type=script&lang=js&"
import style0 from "./TimeAgo.vue?vue&type=style&index=0&id=7d93a159&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d93a159",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d93a159')) {
      api.createRecord('7d93a159', component.options)
    } else {
      api.reload('7d93a159', component.options)
    }
    module.hot.accept("./TimeAgo.vue?vue&type=template&id=7d93a159&scoped=true&", function () {
      api.rerender('7d93a159', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ui/TimeAgo.vue"
export default component.exports